import React from 'react';

export const AuthCheck = ({ isOpen, onClose, onGoogleSignIn, showSignUp = false }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4">
        <h2 className="text-xl font-bold mb-4">
          {showSignUp ? 'Welcome to 70Lives Business Finance Tracker' : 'Sign In Required'}
        </h2>
        <p className="mb-6 text-gray-600">
          {showSignUp 
            ? 'Start your 14-day free trial of Premium features. Your data will be securely stored in your Google Drive.'
            : 'Please sign in to continue with this action. Your data will be securely stored in your Google Drive.'
          }
        </p>
        
        {showSignUp && (
          <div className="bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-5 h-5 bg-[#4FB368] rounded-full flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="font-medium text-green-800">14-Day Free Trial Includes:</span>
            </div>
            <ul className="space-y-2 ml-7">
              <li className="flex items-start gap-2">
                <span className="text-lg">🎤</span>
                <div className="text-sm">
                  <span className="font-semibold text-green-800">Talk instead of typing</span>
                  <span className="text-green-700"> - Add income or expenses just by speaking</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lg">📸</span>
                <div className="text-sm">
                  <span className="font-semibold text-green-800">Snap & save receipts</span>
                  <span className="text-green-700"> - Take a picture, and we'll fill in the details for you</span>
                </div>
              </li>
              <li className="flex items-center gap-2 bg-gradient-to-r from-green-50 to-emerald-50 p-2 rounded-lg">
                <span className="text-lg">✨</span>
                <span className="font-semibold text-green-800">All premium features</span>
              </li>
              <li className="flex items-center gap-2 bg-gradient-to-r from-blue-50 to-cyan-50 p-2 rounded-lg">
                <span className="text-lg">💳</span>
                <span className="font-semibold text-blue-800">No credit card required</span>
              </li>
            </ul>
          </div>
        )}
        
        <div className="space-y-4">
          <button
            onClick={onGoogleSignIn}
            className="w-full bg-[#4FB368] text-white px-4 py-3 rounded-lg hover:bg-opacity-90 transition flex items-center justify-center gap-2"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12.545,12.151L12.545,12.151c0,1.054,0.855,1.909,1.909,1.909h3.536c-0.607,1.972-2.405,3.404-4.536,3.404c-2.626,0-4.754-2.128-4.754-4.754s2.128-4.754,4.754-4.754c1.26,0,2.405,0.492,3.255,1.29l1.534-1.534C16.455,6.892,14.426,6,12.545,6C8.901,6,6,8.901,6,12.545s2.901,6.545,6.545,6.545c4.017,0,6.545-2.927,6.545-6.545V11.5h-6.545V12.151z"
              />
            </svg>
            {showSignUp ? 'Start Free Trial with Google' : 'Sign in with Google'}
          </button>
          
          <button
            onClick={onClose}
            className="w-full border border-gray-300 px-4 py-3 rounded-lg hover:bg-gray-50 transition"
          >
            Cancel
          </button>
        </div>
        
        <div className="mt-6 text-xs text-gray-500">
          <p>Your financial data is stored only in your personal Google Drive account.</p>
          {showSignUp && (
            <p className="mt-2">After 14 days, you can continue with our Free plan or upgrade to Premium for €9.99/month.</p>
          )}
        </div>
      </div>
    </div>
  );
};
